import "./GetInTouch.module.css";
import MainHeader from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import RequestTechnicalSupport from "./sections/RequestTechnicalSupport";
import OurHeadquarters from "./sections/OurHeadquarters";
import SocialGallery from "./sections/SocialGallery";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Sticky solid header */}
      <MainHeader />

      {/* Hero with charcoal gradient overlay and breadcrumb */}
      <PageHero breadcrumbLabel="Get in Touch" eyebrow="CONTACT MATT" title="Contact Your Southampton Roofers" intro="Get in touch with Firststop Roofing Ltd for trusted roofing services in Southampton. Tell us about your project and Matt will provide a free, no-obligation quote." imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/new-tiled-roof-southampton.jpg" imageAlt="New tiled roof completed in Southampton by Firststop Roofing Ltd" />

      {/* Quote Section (white bg) with multi-step wizard + contact sidebar */}
      <RequestTechnicalSupport />

      {/* Our Service Area Section (#F7F5F1 secondary bg) */}
      <OurHeadquarters />

      {/* Recent Projects Gallery (white bg) */}
      <SocialGallery />

      {/* Shared CTA Band (#15191D charcoal) */}
      <CtaBand />

      {/* Shared Footer */}
      <Footer />
    </div>;
}